import base from "./base";
import axios from "@/utils/request";

const api = {
    /**
     * 登陆——获取验证码
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getMobileCaptcha: function(params) {
        return axios.post(base.baseUrl + base.getMobileCaptcha, params)
    },
    /**
     * 登陆——手机号
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getLoginByMobile: function(params) {
        return axios.post(base.baseUrl + base.getLoginByMobile, params,)
    },
    /**
     * QQ登录 获取用户信息
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getTencentInfo: function(params){
        return axios.get(base.baseUrl + base.tencentGetInfo, {
            params:params
        })
    },
    getLoginByTencent:function(params){
        return axios.post(base.baseUrl + base.getLoginByTencent, params)
    },
    /**
     * 微信 获取用户信息
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getWeChatInfo: function(params){

        return axios.get(base.baseUrl + base.weChatGetInfo, {
            params:params
        })
    },
    getLoginByWeChat: function(params){
        return axios.post(base.baseUrl + base.getLoginByWeChat, params)
    },
    /**
     * Apple 获取用户信息
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getAppleInfo: function(params){


        return axios.get(base.baseUrl + base.getAppleInfo, {
            params:params
        })
    },
    getLoginByApple: function(params){
        return axios.post(base.baseUrl + base.getLoginByApple, params)
    },
    /**
     * 用户——获取用户信息
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getUserInfo: function() {
        return axios.get(base.baseUrl + base.getUserInfo, {
            headers: {
                Token: localStorage.getItem("userId")
            }
        })
    },
    /**
     * 同步用户清单数据
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getSyncList: function(params) {
        return axios.post(base.baseUrl + base.syncList, params, {
            headers: {
                Token: localStorage.getItem("userId")
            }
        })
    },
    /**
     * 上传图片——oss
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    ossPutImage: function(params){
        return axios.post(base.baseUrl + base.ossPutImage, params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        })
    },
    /**
     * 删除图片——oss
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    ossDeleteImage: function(params){

        // return axios.post("/local_api" + base.ossDeleteImage, params)
        return axios.post(base.baseUrl + base.ossDeleteImage, params)
    },
}

export default api;